export default "__VITE_ASSET__CS2HuNuf__"